import api from './api';

export const getDashboardStats       = ()         => api.get('/api/stats/dashboard');
export const getCommandCenter        = ()         => api.get('/api/stats/command-center');
export const getAdminUsers           = (params)   => api.get('/api/admin/users', { params });
export const createAdminUser         = (data)     => api.post('/api/admin/users', data);
export const updateAdminStatus       = (id, isActive) => api.put(`/api/admin/users/${id}/status`, { isActive });
export const updateAdminDetails      = (id, data)     => api.patch(`/api/admin/users/${id}/details`, data);
export const sendPasswordReset       = (userId)   => api.post(`/api/admin/users/${userId}/send-reset`);
export const generateMonthlyPayments = (data)     => api.post('/api/payments/generate-monthly', data);
